import { render, staticRenderFns } from "./bread-crumb.vue?vue&type=template&id=2ac3e434&scoped=true"
import script from "./bread-crumb.ts?vue&type=script&lang=ts&external"
export * from "./bread-crumb.ts?vue&type=script&lang=ts&external"
import style0 from "./bread-crumb.less?vue&type=style&index=0&id=2ac3e434&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac3e434",
  null
  
)

export default component.exports